<div fxLayout="row" fxLayout.lt-md="column">
  <mat-card [fxFlex.gt-sm]="!isAddMode ? 50 : 100" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card-content>
      <form [formGroup]="overrideForm" (ngSubmit)="onSubmit()" class="basic-form">
        <div fxLayout="row wrap" fxFlexAlign="center" class="row">
          <mat-form-field fxFlex="100" class="p-10">
            <mat-label>Caller Reference Key</mat-label>
            <input type="text" matInput formControlName="callerReferenceKey" placeholder="Caller Reference Key">
            <mat-error *ngIf="form.callerReferenceKey.hasError('required')">
              Caller Reference Key is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-lg="50" fxFlex="100" class="p-10">
            <mat-label>Version</mat-label>
            <input type="number" matInput min="1" step="1" formControlName="version" placeholder="Version Number">
            <mat-error *ngIf="form.version.hasError('required')">
              Version is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayoutAlign="end center" fxLayoutGap="15px">
          <button type="submit" class="add-action-button" mat-flat-button color="primary"
            [disabled]="!overrideForm.valid">
            <mat-icon>done</mat-icon> Save
          </button>
          <button type="button" class="reset-button" mat-stroked-button color="basic" (click)="showEnvironmentView()">
            <mat-icon>clear</mat-icon> Cancel
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
